<template>
  <button
    v-on="$listeners"
    class="button"
    :class="[{ 'is-dark': variant === 'primary' }]"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "BaseButton",
  props: {
    variant: {
      type: String,
      default: "primary",
      validator: val => ["primary", "secondary"].indexOf(val) !== -1
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  min-width: 100px;
  font-weight: bold;
}
</style>
